document.addEventListener('DOMContentLoaded', function () {
  Vue.component('v-pagination', window['vue-plain-pagination']);
  Vue.component('star-rating', window['VueStarRating'].default);

  new Vue({
    el: '#reviews-app',
    template: `
<div id="q-reviews-app" class="q-reviews-container">
  <div>
    <div id="reviews-if-you-read-this-then-you-stupid" style="display:none">
      <a href="#q-reviews-app" class="q-reviews-product-rating">
        <star-rating :rating="averageRating" :read-only="true" :star-size="20" :show-rating="false"
               :increment="0.01"
               style="display:inline-block" active-color="#39b57b" active-border-color="#39b57b"
               glow-color="#39b57b"></star-rating>
        <p>{{averageRating.toFixed(1)}} ({{totalReviews}} recensioner)</p>
      </a>
    </div>
    <div>
      <h3 class="q-reviews-container-title">Kundrecensioner</h3>
      <div class="q-reviews-rating">
        <p>{{averageRating.toFixed(1)}}</p>
        <star-rating :rating="averageRating" :read-only="true" :star-size="20" :show-rating="false"
                     :increment="0.01"
                     style="display:inline-block" active-color="#39b57b" active-border-color="#39b57b"
                     glow-color="#39b57b"></star-rating>
      </div>
      <p class="q-reviews-rating-value">{{totalReviews}} recensioner</p>
    </div>
    <div class="q-review-create">
      <button class="q-review-btn q-review-btn-create" type="button" v-on:click="toggleCreateReview()">
        Skriv en recension
      </button>
      <div class="q-review-success" v-if="submittedReview && createReviewOpened">
        <h1>Tack för din recension!</h1>
      </div>
      <div class="q-review-collapse"
           v-bind:class="{ 'q-review-collapse-open': createReviewOpened && !submittedReview }">
        <div class="q-review-collapse__content">
          <div class="q-reviews-form">
            <p v-if="errors.length">
              <b>Vänligen korrigera följande fel:</b>
            <ul>
              <li v-for="error in errors">{{ error }}</li>
            </ul>
            </p>
            <div>
              <div class="q-reviews-form-input">
                <label for="name">Namn</label>
                <input
                        id="name"
                        v-model="name"
                        type="text"
                        name="name"
                />
              </div>
              <div class="q-reviews-form-input">
                <label for="email">E-post</label>
                <input
                        id="email"
                        v-model="email"
                        type="email"
                        name="email"
                />
              </div>
            </div>
            <div class="q-reviews-form-input" style="padding-bottom:8px;">
              <label for="rating">Betyg</label>
              <star-rating :rating="4" :star-size="20" :show-rating="false" v-model="rating"
                           style="display:inline-block" active-color="#39b57b" active-border-color="#39b57b"
                           glow-color="#39b57b"></star-rating>
            </div>
            <div class="q-reviews-form-input">
              <label for="title">Titel</label>
              <input
                      id="title"
                      v-model="title"
                      type="text"
                      name="title"
              />
            </div>
            <div class="q-reviews-form-input">
              <label for="description">Beskrivning</label>
              <textarea
                      id="description"
                      v-model="description"
                      name="description"
                      style="min-width: 300px"
              />
            </div>
            <div>
              <button
                      type="button"
                      class="q-review-btn"
                      v-on:click="submitForm"
              >
                Skicka
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="q-reviews-row">
    <div v-for='review in showingReviews' :key='review.id' v-if='renderPage' class="q-review-card"
         :id="'id_' + review.id">
      <div class="q-review-card__header">
        <star-rating :rating="review.stars" :read-only="true" :star-size="16" :show-rating="false"
                     style="display:inline-block" active-color="#39b57b" active-border-color="#39b57b"
                     glow-color="#39b57b"></star-rating>
        <span class="q-verified-buyer-badge" v-if="review.verified">
                    <img src="/cdn/shop/t/2/assets/q-verified.svg" alt="verified" style="width: 16px;height: 16px;">
                    Verifierad
                  </span>
      </div>
      <div class="q-review-card__meta">{{review.name}} {{review.reviewed_at}}</div>
      <div class="q-review-card__content">
        <p class="q-review-card__title">{{review.title}}</p>
        <p class="q-review-card__desc">{{review.description}}</p>
        <div class="q-review-card__photos">
          <div v-for='photo in review.photos' class="q-review-card__photo" v-on:click="expandImage">
            <img :src="photo.thumb" alt="review photo" :data-full-url="photo.large">
          </div>
        </div>
      </div>
    </div>
  </div>
  <v-pagination v-model="currentPage" :page-count="total"></v-pagination>
</div>
`,
    data: {
      reviews: [],
      showingReviews: [],
      renderPage: false,
      errors: [],
      name: null,
      title: null,
      email: null,
      description: null,
      rating: null,
      product_id: null,
      currentPage: 1,
      lastPage: 1,
      total: 9,
      totalReviews: 0,
      averageRating: 0,
      createReviewOpened: false,
      submittedReview: false,
    },
    mounted() {
      this.getReviews();
    },
    updated() {
      this.listReviewsForPage(this.currentPage);
    },
    methods: {
      getReviews() {
        const vm = this;
        const product_id = document.getElementById("reviews-app-holder").getAttribute("data-product-id");
        fetch('https://q-reviews.kopsmart.eu/reviews?slug=' + product_id + "&page=" + vm.currentPage)
            .then(response => response.json())
            .then((data) => {
              vm.renderPage = true;
              vm.currentPage = 1;
              vm.totalReviews = data.reviews.length;
              vm.product_id = product_id;
              vm.total = Math.ceil(data.reviews.length / 10);
              let totalStars = 0;
              vm.reviews = data.reviews.filter((item) => {
                let tempInitials = "";
                totalStars = totalStars + item.stars;
                item.name.split(' ').forEach((val) => tempInitials = tempInitials + val.slice(0, 1));

                item.initials = tempInitials.slice(0, 2);
                item.country = item.country ? item.country : "USA";
                item.country_img_url = "https://relax-enough.s3.eu-north-1.amazonaws.com/svg/" + (item.country_code ? item.country_code : "us") + ".svg";
                return true;
              });
              vm.showingReviews = data.reviews.slice(0, 10);
              vm.averageRating = totalStars / data.reviews.length;

              setTimeout(() => {
                const productRatingEl = document.getElementById('reviews-if-you-read-this-then-you-stupid');
                const productRatingPlacementEl = document.getElementById('reviews-stupid-monkey-place');

                if (productRatingPlacementEl && productRatingEl) {
                  productRatingPlacementEl.innerHTML = productRatingEl.innerHTML;
                }
              }, 100)
            });
      },
      checkForm() {
        this.errors = [];
        if (!this.name) this.errors.push("Name required.");
        if (!this.email) {
          this.errors.push("Email required.");
        } else if (!this.validEmail(this.email)) {
          this.errors.push("Valid email required.");
        }
        if (!this.title) {
          this.errors.push("Title required.");
        }
        if (!this.rating) {
          this.errors.push("Rating required.");
        }
        if (!this.description) {
          this.errors.push("Description required.");
        }
        if (!this.errors.length) return true;
      },
      async postData(url = '', data = {}) {
        const response = await fetch(url, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
      },
      validEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      submitForm() {
        const submit = this.checkForm();
        const vm = this;
        const product_id = document.getElementById("reviews-app-holder").getAttribute("data-product-id");

        if (submit) {
          vm.postData('https://q-reviews.kopsmart.eu/reviews_create?slug=' + product_id, {
            name: this.name,
            email: this.email,
            title: this.title,
            stars: this.rating,
            description: this.description
          }).then((data) => {
            vm.submittedReview = true;
          });

        }
      },
      expandImage(e) {
        const firstSrc = e.target.tagName === 'DIV' ? e.target.querySelector('img').dataset.fullUrl : e.target.dataset.fullUrl

        BigPicture({
          // element from which animation starts (required)
          el: e.target,
          // image url
          imgSrc: firstSrc,
        })
      },
      listReviewsForPage(page) {
        const perPage = 10;
        const start = page > 1 ? (page - 1) * perPage : 0;
        const end = start + perPage;
        if (page !== this.lastPage) {
          this.scrollToTop();
          this.showingReviews = this.reviews.slice(start, end);
          this.lastPage = page;
        }
      },
      scrollToTop(duration) {
        window.scrollTo({
          top: document.getElementById('reviews-app-holder').offsetTop - 50,
          left: 0,
          behavior: 'smooth'
        });
      },
      toggleCreateReview() {
        this.createReviewOpened = !this.createReviewOpened;
        let scrollHeight = document.querySelector('.q-review-collapse__content').scrollHeight;
        if (!this.createReviewOpened) {
          scrollHeight = 0;
        }
        document.querySelector('.q-review-collapse').style.maxHeight = scrollHeight + 'px';
      }
    }
  });
});
